import { render, staticRenderFns } from "./LoginSso.vue?vue&type=template&id=7024ab6d&scoped=true"
import script from "./LoginSso.vue?vue&type=script&lang=ts"
export * from "./LoginSso.vue?vue&type=script&lang=ts"
import style0 from "./LoginSso.vue?vue&type=style&index=0&id=7024ab6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7024ab6d",
  null
  
)

export default component.exports